import $ from "jquery";
import Select from "./select";

export default class DataTable {
    constructor() {
        this.datatable = document.querySelector(".datatable");
        if (this.datatable) {
            document.addEventListener("DOMContentLoaded", () => {
                this.rowPrototype = this.datatable ? this.datatable.getAttribute("data-prototype") : null;
                this.rowsWithEventListener = 0;
                this.addButtons = document.querySelectorAll("td.add-rows");
                this.selectHandler = new Select();
                this.init();
            }, false);
        }
    }

    init() {
        this.addButtons.forEach((addButton) => {
            addButton.addEventListener("click", () => {
                this.addRows(addButton);
            });
        });
        this.initIndexes();
        this.bindDfsTrash();
    }

    initIndexes() {
        let index = 1;
        this.datatable.querySelectorAll("td.index").forEach((td) => {
            td.innerHTML = index;
            index += 1;
        });
    }

    toggleInputs(td) {
        const input = td.querySelector("input");
        if (input) {
            input.readOnly = !input.readOnly;
            input.classList.toggle("bb-main-scd-1:h");
            input.classList.toggle("bb-main-scd-1:f");
        }
    }

    toggleSelects(td) {
        const select = td.querySelector("select");
        if (select) {
            select.readonly = select.readonly ? !select.readonly : true;
        }
    }

    toggleCheckbox(checkbox) {
        if (checkbox.getAttribute("checked")) {
            checkbox.removeAttribute("checked");
        } else {
            checkbox.setAttribute("checked", "true");
        }
    }

    bindDfsTrash() {
        const trashes = document.querySelectorAll(".datatable .dfs-trash");

        trashes.forEach((trash, index) => {
            if (index >= this.rowsWithEventListener) {
                trash.addEventListener("click", (event) => {
                    this.toggleCheckbox(event.target.querySelector("input[type='checkbox']"));
                    trash.parentElement.querySelectorAll("td").forEach((td) => {
                        if (!td.classList.contains("dfs-trash")) {
                            td.classList.toggle("dfs-removed");
                            this.toggleInputs(td);
                            this.toggleSelects(td);
                        } else {
                            td.classList.toggle("cancel");
                        }
                        const overline = td.querySelector(".overline");
                        if (overline) {
                            overline.classList.toggle("d-n");
                        }
                    });
                });
                this.rowsWithEventListener += 1;
            }
        });
    }

    addRows(addButton) {
        if (this.rowPrototype) {
            const tbody = addButton.parentElement.parentElement;
            const rows = Array.from(tbody.querySelectorAll("tr")).filter(row => !row.querySelector("td").classList.contains("add-rows"));

            const row = $(this.rowPrototype.replace(/__name__/g, (rows.length + 1).toString())).get()[0];
            $(".add-rows").parent().before(row);
            row.dispatchEvent(new Event("rowAdded", { bubbles: true }));

            this.bindDfsTrash();
        }
    }
}
